<template>
  <div class="chart">
    <commitChart v-if="chartData" :chartData="chartData" :options="options" />
  </div>
</template>

<script>
  import commitChart from '@/chart/commitChart.js'

  export default {
    name: 'Chart',
    props: {
      title: {
        type: String
      },
      label: {
        type: String
      },
      labels: {
        type: Array
      },
      dataPoints: {
        type: Array
      },
      secondaryDataPoints: {
        type: Array
      },
      secondaryLabel: {
        type: String
      },
      xLabel: {
        type: String
      },
      yLabel: {
        type: String
      },
      min: {
        type: Number
      },
      max: {
        type: Number
      }
    },
    components: {
      commitChart
    },
    computed: {
      chartData: function () {
        return {
          labels: this.labels,
          datasets: [
            {
              label: this.label,
              fill: false,
              data: this.preparedData,
              showLine: true,
              radius: 0,
              borderColor: '#00AA00',
              backgroundColor: '#00AA00',
              borderWidth: 1
            },
            {
              label: this.secondaryLabel,
              fill: false,
              showLine: true,
              borderColor: '#0000ff',
              backgroundColor: '#0000ff',
              data: this.preparedSecondaryData,
              borderWidth: 1,
              radius: 0
            }
          ]
        }
      },
      preparedData () {
        return this.dataPoints.map((o, i) => {
          return { x: this.labels[i], y: o }
        })
      },
      preparedSecondaryData () {
        return [].concat(...this.secondaryDataPoints.map((p) => {
          return [
            { x: p.beginStimulus, y: p.beginResponse },
            { x: p.endStimulus, y: p.endResponse },
            {}
          ]
        }))
      },

      options () {
        return {
          title: {
            display: true,
            text: this.title
          },
          responsive: true,
          elements: {
            line: {
              tension: 0
            }
          },
          scales: {
            xAxes: [{
              display: true,
              scaleLabel: {
                display: true,
                labelString: this.xLabel
              },
              ticks: {
                min: Math.min(...this.labels),
                max: Math.max(...this.labels),
                stepSize: (Math.max(...this.labels) - Math.min(...this.labels)) / 9,
                userCallback: function (label, index, labels) {
                  return Number(label).toFixed(2)
                }
              }
            }],
            yAxes: [{
              display: true,
              scaleLabel: {
                display: true,
                labelString: this.yLabel
              },
              ticks: {
                beginAtZero: true,
                suggestedMin: Math.min(...this.dataPoints),
                suggestedMax: Math.max(...this.dataPoints)
              }
            }]
          }
        }
      }
    },
    data () {
      return {

      }
    }
  }
</script>

<style lang="scss" scoped>

</style>
